namespace Matrix.Dashboards {

    export interface MyBookmarksWidgetOptions extends IWidgetOptions {
    }

    @Serenity.Decorators.registerClass('Matrix.Dashboards.MyBookmarksWidget')
    export class MyBookmarksWidget extends Serenity.Widget<MyBookmarksWidgetOptions> {

        private data: Q.Dictionary<string>;

        constructor(element: JQuery, opt: any) {
            super(element, opt);

            this.refresh();
        }

        protected refresh() {

            Common.UserPreferenceService.Retrieve({
                PreferenceTypeCode: "UserPreferenceStorage",
                PreferenceName: "FavoritePages"
            },
                (response) => {
                    this.data = JSON.parse(response.Value || "{}");
                    this.updateContent();
                }, {
                    onError: response => {
                        this.displayError(response?.Error?.Message);
                    }
            });
        }
        
        displayError(message: string) {
            if (message && this.options.__designer)
                Q.notifyError(message);
            this.element.html('<div class="dash-widget-broken"><i class="fa fa-bug"></i></div>')
                .children().attr('title', message);
        }

        protected updateContent(): void {
            this.element.html('');

            if (!this.data)
                return;

            var keys = Object.keys(this.data);
            keys.sort();

            this.element.html(`<div class="row">${keys.map(k =>
                `<div class="col-xs-6 col-sm-4 col-lg-3 mb-1">
<a href="${Q.attrEncode(this.data[k])}"><i class="fa fa-external-link pull-right"></i> ${Q.htmlEncode(k)}</a></div>`).join('\n')}</div>`);
        }

    }

}